(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global['ot-auth'] = {}));
}(this, (function (exports) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    var bind = function bind(fn, thisArg) {
      return function wrap() {
        var args = new Array(arguments.length);

        for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i];
        }

        return fn.apply(thisArg, args);
      };
    };

    /*global toString:true*/
    // utils is a library of generic helper functions non-specific to axios


    var toString = Object.prototype.toString;
    /**
     * Determine if a value is an Array
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is an Array, otherwise false
     */

    function isArray(val) {
      return toString.call(val) === '[object Array]';
    }
    /**
     * Determine if a value is undefined
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if the value is undefined, otherwise false
     */


    function isUndefined(val) {
      return typeof val === 'undefined';
    }
    /**
     * Determine if a value is a Buffer
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is a Buffer, otherwise false
     */


    function isBuffer(val) {
      return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
    }
    /**
     * Determine if a value is an ArrayBuffer
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is an ArrayBuffer, otherwise false
     */


    function isArrayBuffer(val) {
      return toString.call(val) === '[object ArrayBuffer]';
    }
    /**
     * Determine if a value is a FormData
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is an FormData, otherwise false
     */


    function isFormData(val) {
      return typeof FormData !== 'undefined' && val instanceof FormData;
    }
    /**
     * Determine if a value is a view on an ArrayBuffer
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
     */


    function isArrayBufferView(val) {
      var result;

      if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
        result = ArrayBuffer.isView(val);
      } else {
        result = val && val.buffer && val.buffer instanceof ArrayBuffer;
      }

      return result;
    }
    /**
     * Determine if a value is a String
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is a String, otherwise false
     */


    function isString(val) {
      return typeof val === 'string';
    }
    /**
     * Determine if a value is a Number
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is a Number, otherwise false
     */


    function isNumber(val) {
      return typeof val === 'number';
    }
    /**
     * Determine if a value is an Object
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is an Object, otherwise false
     */


    function isObject(val) {
      return val !== null && typeof val === 'object';
    }
    /**
     * Determine if a value is a plain Object
     *
     * @param {Object} val The value to test
     * @return {boolean} True if value is a plain Object, otherwise false
     */


    function isPlainObject(val) {
      if (toString.call(val) !== '[object Object]') {
        return false;
      }

      var prototype = Object.getPrototypeOf(val);
      return prototype === null || prototype === Object.prototype;
    }
    /**
     * Determine if a value is a Date
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is a Date, otherwise false
     */


    function isDate(val) {
      return toString.call(val) === '[object Date]';
    }
    /**
     * Determine if a value is a File
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is a File, otherwise false
     */


    function isFile(val) {
      return toString.call(val) === '[object File]';
    }
    /**
     * Determine if a value is a Blob
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is a Blob, otherwise false
     */


    function isBlob(val) {
      return toString.call(val) === '[object Blob]';
    }
    /**
     * Determine if a value is a Function
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is a Function, otherwise false
     */


    function isFunction(val) {
      return toString.call(val) === '[object Function]';
    }
    /**
     * Determine if a value is a Stream
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is a Stream, otherwise false
     */


    function isStream(val) {
      return isObject(val) && isFunction(val.pipe);
    }
    /**
     * Determine if a value is a URLSearchParams object
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is a URLSearchParams object, otherwise false
     */


    function isURLSearchParams(val) {
      return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
    }
    /**
     * Trim excess whitespace off the beginning and end of a string
     *
     * @param {String} str The String to trim
     * @returns {String} The String freed of excess whitespace
     */


    function trim(str) {
      return str.replace(/^\s*/, '').replace(/\s*$/, '');
    }
    /**
     * Determine if we're running in a standard browser environment
     *
     * This allows axios to run in a web worker, and react-native.
     * Both environments support XMLHttpRequest, but not fully standard globals.
     *
     * web workers:
     *  typeof window -> undefined
     *  typeof document -> undefined
     *
     * react-native:
     *  navigator.product -> 'ReactNative'
     * nativescript
     *  navigator.product -> 'NativeScript' or 'NS'
     */


    function isStandardBrowserEnv() {
      if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
        return false;
      }

      return typeof window !== 'undefined' && typeof document !== 'undefined';
    }
    /**
     * Iterate over an Array or an Object invoking a function for each item.
     *
     * If `obj` is an Array callback will be called passing
     * the value, index, and complete array for each item.
     *
     * If 'obj' is an Object callback will be called passing
     * the value, key, and complete object for each property.
     *
     * @param {Object|Array} obj The object to iterate
     * @param {Function} fn The callback to invoke for each item
     */


    function forEach(obj, fn) {
      // Don't bother if no value provided
      if (obj === null || typeof obj === 'undefined') {
        return;
      } // Force an array if not already something iterable


      if (typeof obj !== 'object') {
        /*eslint no-param-reassign:0*/
        obj = [obj];
      }

      if (isArray(obj)) {
        // Iterate over array values
        for (var i = 0, l = obj.length; i < l; i++) {
          fn.call(null, obj[i], i, obj);
        }
      } else {
        // Iterate over object keys
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn.call(null, obj[key], key, obj);
          }
        }
      }
    }
    /**
     * Accepts varargs expecting each argument to be an object, then
     * immutably merges the properties of each object and returns result.
     *
     * When multiple objects contain the same key the later object in
     * the arguments list will take precedence.
     *
     * Example:
     *
     * ```js
     * var result = merge({foo: 123}, {foo: 456});
     * console.log(result.foo); // outputs 456
     * ```
     *
     * @param {Object} obj1 Object to merge
     * @returns {Object} Result of all merge properties
     */


    function merge()
    /* obj1, obj2, obj3, ... */
    {
      var result = {};

      function assignValue(val, key) {
        if (isPlainObject(result[key]) && isPlainObject(val)) {
          result[key] = merge(result[key], val);
        } else if (isPlainObject(val)) {
          result[key] = merge({}, val);
        } else if (isArray(val)) {
          result[key] = val.slice();
        } else {
          result[key] = val;
        }
      }

      for (var i = 0, l = arguments.length; i < l; i++) {
        forEach(arguments[i], assignValue);
      }

      return result;
    }
    /**
     * Extends object a by mutably adding to it the properties of object b.
     *
     * @param {Object} a The object to be extended
     * @param {Object} b The object to copy properties from
     * @param {Object} thisArg The object to bind function to
     * @return {Object} The resulting value of object a
     */


    function extend(a, b, thisArg) {
      forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') {
          a[key] = bind(val, thisArg);
        } else {
          a[key] = val;
        }
      });
      return a;
    }
    /**
     * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
     *
     * @param {string} content with BOM
     * @return {string} content value without BOM
     */


    function stripBOM(content) {
      if (content.charCodeAt(0) === 0xFEFF) {
        content = content.slice(1);
      }

      return content;
    }

    var utils = {
      isArray: isArray,
      isArrayBuffer: isArrayBuffer,
      isBuffer: isBuffer,
      isFormData: isFormData,
      isArrayBufferView: isArrayBufferView,
      isString: isString,
      isNumber: isNumber,
      isObject: isObject,
      isPlainObject: isPlainObject,
      isUndefined: isUndefined,
      isDate: isDate,
      isFile: isFile,
      isBlob: isBlob,
      isFunction: isFunction,
      isStream: isStream,
      isURLSearchParams: isURLSearchParams,
      isStandardBrowserEnv: isStandardBrowserEnv,
      forEach: forEach,
      merge: merge,
      extend: extend,
      trim: trim,
      stripBOM: stripBOM
    };

    function encode(val) {
      return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    }
    /**
     * Build a URL by appending params to the end
     *
     * @param {string} url The base of the url (e.g., http://www.google.com)
     * @param {object} [params] The params to be appended
     * @returns {string} The formatted url
     */


    var buildURL = function buildURL(url, params, paramsSerializer) {
      /*eslint no-param-reassign:0*/
      if (!params) {
        return url;
      }

      var serializedParams;

      if (paramsSerializer) {
        serializedParams = paramsSerializer(params);
      } else if (utils.isURLSearchParams(params)) {
        serializedParams = params.toString();
      } else {
        var parts = [];
        utils.forEach(params, function serialize(val, key) {
          if (val === null || typeof val === 'undefined') {
            return;
          }

          if (utils.isArray(val)) {
            key = key + '[]';
          } else {
            val = [val];
          }

          utils.forEach(val, function parseValue(v) {
            if (utils.isDate(v)) {
              v = v.toISOString();
            } else if (utils.isObject(v)) {
              v = JSON.stringify(v);
            }

            parts.push(encode(key) + '=' + encode(v));
          });
        });
        serializedParams = parts.join('&');
      }

      if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');

        if (hashmarkIndex !== -1) {
          url = url.slice(0, hashmarkIndex);
        }

        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
      }

      return url;
    };

    function InterceptorManager() {
      this.handlers = [];
    }
    /**
     * Add a new interceptor to the stack
     *
     * @param {Function} fulfilled The function to handle `then` for a `Promise`
     * @param {Function} rejected The function to handle `reject` for a `Promise`
     *
     * @return {Number} An ID used to remove interceptor later
     */


    InterceptorManager.prototype.use = function use(fulfilled, rejected) {
      this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected
      });
      return this.handlers.length - 1;
    };
    /**
     * Remove an interceptor from the stack
     *
     * @param {Number} id The ID that was returned by `use`
     */


    InterceptorManager.prototype.eject = function eject(id) {
      if (this.handlers[id]) {
        this.handlers[id] = null;
      }
    };
    /**
     * Iterate over all the registered interceptors
     *
     * This method is particularly useful for skipping over any
     * interceptors that may have become `null` calling `eject`.
     *
     * @param {Function} fn The function to call for each interceptor
     */


    InterceptorManager.prototype.forEach = function forEach(fn) {
      utils.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) {
          fn(h);
        }
      });
    };

    var InterceptorManager_1 = InterceptorManager;

    /**
     * Transform the data for a request or a response
     *
     * @param {Object|String} data The data to be transformed
     * @param {Array} headers The headers for the request or response
     * @param {Array|Function} fns A single function or Array of functions
     * @returns {*} The resulting transformed data
     */


    var transformData = function transformData(data, headers, fns) {
      /*eslint no-param-reassign:0*/
      utils.forEach(fns, function transform(fn) {
        data = fn(data, headers);
      });
      return data;
    };

    var isCancel = function isCancel(value) {
      return !!(value && value.__CANCEL__);
    };

    var normalizeHeaderName = function normalizeHeaderName(headers, normalizedName) {
      utils.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
          headers[normalizedName] = value;
          delete headers[name];
        }
      });
    };

    /**
     * Update an Error with the specified config, error code, and response.
     *
     * @param {Error} error The error to update.
     * @param {Object} config The config.
     * @param {string} [code] The error code (for example, 'ECONNABORTED').
     * @param {Object} [request] The request.
     * @param {Object} [response] The response.
     * @returns {Error} The error.
     */

    var enhanceError = function enhanceError(error, config, code, request, response) {
      error.config = config;

      if (code) {
        error.code = code;
      }

      error.request = request;
      error.response = response;
      error.isAxiosError = true;

      error.toJSON = function toJSON() {
        return {
          // Standard
          message: this.message,
          name: this.name,
          // Microsoft
          description: this.description,
          number: this.number,
          // Mozilla
          fileName: this.fileName,
          lineNumber: this.lineNumber,
          columnNumber: this.columnNumber,
          stack: this.stack,
          // Axios
          config: this.config,
          code: this.code
        };
      };

      return error;
    };

    /**
     * Create an Error with the specified message, config, error code, request and response.
     *
     * @param {string} message The error message.
     * @param {Object} config The config.
     * @param {string} [code] The error code (for example, 'ECONNABORTED').
     * @param {Object} [request] The request.
     * @param {Object} [response] The response.
     * @returns {Error} The created error.
     */


    var createError = function createError(message, config, code, request, response) {
      var error = new Error(message);
      return enhanceError(error, config, code, request, response);
    };

    /**
     * Resolve or reject a Promise based on response status.
     *
     * @param {Function} resolve A function that resolves the promise.
     * @param {Function} reject A function that rejects the promise.
     * @param {object} response The response.
     */


    var settle = function settle(resolve, reject, response) {
      var validateStatus = response.config.validateStatus;

      if (!response.status || !validateStatus || validateStatus(response.status)) {
        resolve(response);
      } else {
        reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
      }
    };

    var cookies = utils.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
    function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },
        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    }() : // Non standard browser env (web workers, react-native) lack needed support.
    function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() {
          return null;
        },
        remove: function remove() {}
      };
    }();

    /**
     * Determines whether the specified URL is absolute
     *
     * @param {string} url The URL to test
     * @returns {boolean} True if the specified URL is absolute, otherwise false
     */

    var isAbsoluteURL = function isAbsoluteURL(url) {
      // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
      // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
      // by any combination of letters, digits, plus, period, or hyphen.
      return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
    };

    /**
     * Creates a new URL by combining the specified URLs
     *
     * @param {string} baseURL The base URL
     * @param {string} relativeURL The relative URL
     * @returns {string} The combined URL
     */

    var combineURLs = function combineURLs(baseURL, relativeURL) {
      return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
    };

    /**
     * Creates a new URL by combining the baseURL with the requestedURL,
     * only when the requestedURL is not already an absolute URL.
     * If the requestURL is absolute, this function returns the requestedURL untouched.
     *
     * @param {string} baseURL The base URL
     * @param {string} requestedURL Absolute or relative URL to combine
     * @returns {string} The combined full path
     */


    var buildFullPath = function buildFullPath(baseURL, requestedURL) {
      if (baseURL && !isAbsoluteURL(requestedURL)) {
        return combineURLs(baseURL, requestedURL);
      }

      return requestedURL;
    };

    // c.f. https://nodejs.org/api/http.html#http_message_headers


    var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];
    /**
     * Parse headers into an object
     *
     * ```
     * Date: Wed, 27 Aug 2014 08:58:49 GMT
     * Content-Type: application/json
     * Connection: keep-alive
     * Transfer-Encoding: chunked
     * ```
     *
     * @param {String} headers Headers needing to be parsed
     * @returns {Object} Headers parsed into an object
     */

    var parseHeaders = function parseHeaders(headers) {
      var parsed = {};
      var key;
      var val;
      var i;

      if (!headers) {
        return parsed;
      }

      utils.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = utils.trim(line.substr(0, i)).toLowerCase();
        val = utils.trim(line.substr(i + 1));

        if (key) {
          if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
            return;
          }

          if (key === 'set-cookie') {
            parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
          } else {
            parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
          }
        }
      });
      return parsed;
    };

    var isURLSameOrigin = utils.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;
      /**
      * Parse a URL to discover it's components
      *
      * @param {String} url The URL to be parsed
      * @returns {Object}
      */

      function resolveURL(url) {
        var href = url;

        if (msie) {
          // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href); // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils

        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);
      /**
      * Determine if a URL shares the same origin as the current location
      *
      * @param {String} requestURL The URL to test
      * @returns {boolean} True if URL shares the same origin, otherwise false
      */

      return function isURLSameOrigin(requestURL) {
        var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
      };
    }() : // Non standard browser envs (web workers, react-native) lack needed support.
    function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    }();

    var xhr = function xhrAdapter(config) {
      return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;

        if (utils.isFormData(requestData)) {
          delete requestHeaders['Content-Type']; // Let the browser set it
        }

        var request = new XMLHttpRequest(); // HTTP basic authentication

        if (config.auth) {
          var username = config.auth.username || '';
          var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
          requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }

        var fullPath = buildFullPath(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true); // Set the request timeout in MS

        request.timeout = config.timeout; // Listen for ready state

        request.onreadystatechange = function handleLoad() {
          if (!request || request.readyState !== 4) {
            return;
          } // The request errored out and we didn't get a response, this will be
          // handled by onerror instead
          // With one exception: request that using file: protocol, most browsers
          // will return status as 0 even though it's a successful request


          if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
            return;
          } // Prepare the response


          var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
          var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
          var response = {
            data: responseData,
            status: request.status,
            statusText: request.statusText,
            headers: responseHeaders,
            config: config,
            request: request
          };
          settle(resolve, reject, response); // Clean up request

          request = null;
        }; // Handle browser request cancellation (as opposed to a manual cancellation)


        request.onabort = function handleAbort() {
          if (!request) {
            return;
          }

          reject(createError('Request aborted', config, 'ECONNABORTED', request)); // Clean up request

          request = null;
        }; // Handle low level network errors


        request.onerror = function handleError() {
          // Real errors are hidden from us by the browser
          // onerror should only fire if it's a network error
          reject(createError('Network Error', config, null, request)); // Clean up request

          request = null;
        }; // Handle timeout


        request.ontimeout = function handleTimeout() {
          var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';

          if (config.timeoutErrorMessage) {
            timeoutErrorMessage = config.timeoutErrorMessage;
          }

          reject(createError(timeoutErrorMessage, config, 'ECONNABORTED', request)); // Clean up request

          request = null;
        }; // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.


        if (utils.isStandardBrowserEnv()) {
          // Add xsrf header
          var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

          if (xsrfValue) {
            requestHeaders[config.xsrfHeaderName] = xsrfValue;
          }
        } // Add headers to the request


        if ('setRequestHeader' in request) {
          utils.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
              // Remove Content-Type if data is undefined
              delete requestHeaders[key];
            } else {
              // Otherwise add header to the request
              request.setRequestHeader(key, val);
            }
          });
        } // Add withCredentials to request if needed


        if (!utils.isUndefined(config.withCredentials)) {
          request.withCredentials = !!config.withCredentials;
        } // Add responseType to request if needed


        if (config.responseType) {
          try {
            request.responseType = config.responseType;
          } catch (e) {
            // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
            // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
            if (config.responseType !== 'json') {
              throw e;
            }
          }
        } // Handle progress if needed


        if (typeof config.onDownloadProgress === 'function') {
          request.addEventListener('progress', config.onDownloadProgress);
        } // Not all browsers support upload events


        if (typeof config.onUploadProgress === 'function' && request.upload) {
          request.upload.addEventListener('progress', config.onUploadProgress);
        }

        if (config.cancelToken) {
          // Handle cancellation
          config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) {
              return;
            }

            request.abort();
            reject(cancel); // Clean up request

            request = null;
          });
        }

        if (!requestData) {
          requestData = null;
        } // Send the request


        request.send(requestData);
      });
    };

    var DEFAULT_CONTENT_TYPE = {
      'Content-Type': 'application/x-www-form-urlencoded'
    };

    function setContentTypeIfUnset(headers, value) {
      if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
        headers['Content-Type'] = value;
      }
    }

    function getDefaultAdapter() {
      var adapter;

      if (typeof XMLHttpRequest !== 'undefined') {
        // For browsers use XHR adapter
        adapter = xhr;
      } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
        // For node use HTTP adapter
        adapter = xhr;
      }

      return adapter;
    }

    var defaults = {
      adapter: getDefaultAdapter(),
      transformRequest: [function transformRequest(data, headers) {
        normalizeHeaderName(headers, 'Accept');
        normalizeHeaderName(headers, 'Content-Type');

        if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
          return data;
        }

        if (utils.isArrayBufferView(data)) {
          return data.buffer;
        }

        if (utils.isURLSearchParams(data)) {
          setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
          return data.toString();
        }

        if (utils.isObject(data)) {
          setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
          return JSON.stringify(data);
        }

        return data;
      }],
      transformResponse: [function transformResponse(data) {
        /*eslint no-param-reassign:0*/
        if (typeof data === 'string') {
          try {
            data = JSON.parse(data);
          } catch (e) {
            /* Ignore */
          }
        }

        return data;
      }],

      /**
       * A timeout in milliseconds to abort a request. If set to 0 (default) a
       * timeout is not created.
       */
      timeout: 0,
      xsrfCookieName: 'XSRF-TOKEN',
      xsrfHeaderName: 'X-XSRF-TOKEN',
      maxContentLength: -1,
      maxBodyLength: -1,
      validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
      }
    };
    defaults.headers = {
      common: {
        'Accept': 'application/json, text/plain, */*'
      }
    };
    utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
      defaults.headers[method] = {};
    });
    utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
      defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
    });
    var defaults_1 = defaults;

    /**
     * Throws a `Cancel` if cancellation has been requested.
     */


    function throwIfCancellationRequested(config) {
      if (config.cancelToken) {
        config.cancelToken.throwIfRequested();
      }
    }
    /**
     * Dispatch a request to the server using the configured adapter.
     *
     * @param {object} config The config that is to be used for the request
     * @returns {Promise} The Promise to be fulfilled
     */


    var dispatchRequest = function dispatchRequest(config) {
      throwIfCancellationRequested(config); // Ensure headers exist

      config.headers = config.headers || {}; // Transform request data

      config.data = transformData(config.data, config.headers, config.transformRequest); // Flatten headers

      config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
      utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
        delete config.headers[method];
      });
      var adapter = config.adapter || defaults_1.adapter;
      return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config); // Transform response data

        response.data = transformData(response.data, response.headers, config.transformResponse);
        return response;
      }, function onAdapterRejection(reason) {
        if (!isCancel(reason)) {
          throwIfCancellationRequested(config); // Transform response data

          if (reason && reason.response) {
            reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
          }
        }

        return Promise.reject(reason);
      });
    };

    /**
     * Config-specific merge-function which creates a new config-object
     * by merging two configuration objects together.
     *
     * @param {Object} config1
     * @param {Object} config2
     * @returns {Object} New object resulting from merging config2 to config1
     */


    var mergeConfig = function mergeConfig(config1, config2) {
      // eslint-disable-next-line no-param-reassign
      config2 = config2 || {};
      var config = {};
      var valueFromConfig2Keys = ['url', 'method', 'data'];
      var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
      var defaultToConfig2Keys = ['baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer', 'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName', 'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress', 'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent', 'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'];
      var directMergeKeys = ['validateStatus'];

      function getMergedValue(target, source) {
        if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
          return utils.merge(target, source);
        } else if (utils.isPlainObject(source)) {
          return utils.merge({}, source);
        } else if (utils.isArray(source)) {
          return source.slice();
        }

        return source;
      }

      function mergeDeepProperties(prop) {
        if (!utils.isUndefined(config2[prop])) {
          config[prop] = getMergedValue(config1[prop], config2[prop]);
        } else if (!utils.isUndefined(config1[prop])) {
          config[prop] = getMergedValue(undefined, config1[prop]);
        }
      }

      utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) {
          config[prop] = getMergedValue(undefined, config2[prop]);
        }
      });
      utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
      utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) {
          config[prop] = getMergedValue(undefined, config2[prop]);
        } else if (!utils.isUndefined(config1[prop])) {
          config[prop] = getMergedValue(undefined, config1[prop]);
        }
      });
      utils.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) {
          config[prop] = getMergedValue(config1[prop], config2[prop]);
        } else if (prop in config1) {
          config[prop] = getMergedValue(undefined, config1[prop]);
        }
      });
      var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
      var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
      });
      utils.forEach(otherKeys, mergeDeepProperties);
      return config;
    };

    /**
     * Create a new instance of Axios
     *
     * @param {Object} instanceConfig The default config for the instance
     */


    function Axios(instanceConfig) {
      this.defaults = instanceConfig;
      this.interceptors = {
        request: new InterceptorManager_1(),
        response: new InterceptorManager_1()
      };
    }
    /**
     * Dispatch a request
     *
     * @param {Object} config The config specific for this request (merged with this.defaults)
     */


    Axios.prototype.request = function request(config) {
      /*eslint no-param-reassign:0*/
      // Allow for axios('example/url'[, config]) a la fetch API
      if (typeof config === 'string') {
        config = arguments[1] || {};
        config.url = arguments[0];
      } else {
        config = config || {};
      }

      config = mergeConfig(this.defaults, config); // Set config.method

      if (config.method) {
        config.method = config.method.toLowerCase();
      } else if (this.defaults.method) {
        config.method = this.defaults.method.toLowerCase();
      } else {
        config.method = 'get';
      } // Hook up interceptors middleware


      var chain = [dispatchRequest, undefined];
      var promise = Promise.resolve(config);
      this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        chain.unshift(interceptor.fulfilled, interceptor.rejected);
      });
      this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        chain.push(interceptor.fulfilled, interceptor.rejected);
      });

      while (chain.length) {
        promise = promise.then(chain.shift(), chain.shift());
      }

      return promise;
    };

    Axios.prototype.getUri = function getUri(config) {
      config = mergeConfig(this.defaults, config);
      return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
    }; // Provide aliases for supported request methods


    utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
      /*eslint func-names:0*/
      Axios.prototype[method] = function (url, config) {
        return this.request(mergeConfig(config || {}, {
          method: method,
          url: url,
          data: (config || {}).data
        }));
      };
    });
    utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
      /*eslint func-names:0*/
      Axios.prototype[method] = function (url, data, config) {
        return this.request(mergeConfig(config || {}, {
          method: method,
          url: url,
          data: data
        }));
      };
    });
    var Axios_1 = Axios;

    /**
     * A `Cancel` is an object that is thrown when an operation is canceled.
     *
     * @class
     * @param {string=} message The message.
     */

    function Cancel(message) {
      this.message = message;
    }

    Cancel.prototype.toString = function toString() {
      return 'Cancel' + (this.message ? ': ' + this.message : '');
    };

    Cancel.prototype.__CANCEL__ = true;
    var Cancel_1 = Cancel;

    /**
     * A `CancelToken` is an object that can be used to request cancellation of an operation.
     *
     * @class
     * @param {Function} executor The executor function.
     */


    function CancelToken(executor) {
      if (typeof executor !== 'function') {
        throw new TypeError('executor must be a function.');
      }

      var resolvePromise;
      this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
      });
      var token = this;
      executor(function cancel(message) {
        if (token.reason) {
          // Cancellation has already been requested
          return;
        }

        token.reason = new Cancel_1(message);
        resolvePromise(token.reason);
      });
    }
    /**
     * Throws a `Cancel` if cancellation has been requested.
     */


    CancelToken.prototype.throwIfRequested = function throwIfRequested() {
      if (this.reason) {
        throw this.reason;
      }
    };
    /**
     * Returns an object that contains a new `CancelToken` and a function that, when called,
     * cancels the `CancelToken`.
     */


    CancelToken.source = function source() {
      var cancel;
      var token = new CancelToken(function executor(c) {
        cancel = c;
      });
      return {
        token: token,
        cancel: cancel
      };
    };

    var CancelToken_1 = CancelToken;

    /**
     * Syntactic sugar for invoking a function and expanding an array for arguments.
     *
     * Common use case would be to use `Function.prototype.apply`.
     *
     *  ```js
     *  function f(x, y, z) {}
     *  var args = [1, 2, 3];
     *  f.apply(null, args);
     *  ```
     *
     * With `spread` this example can be re-written.
     *
     *  ```js
     *  spread(function(x, y, z) {})([1, 2, 3]);
     *  ```
     *
     * @param {Function} callback
     * @returns {Function}
     */

    var spread = function spread(callback) {
      return function wrap(arr) {
        return callback.apply(null, arr);
      };
    };

    /**
     * Create an instance of Axios
     *
     * @param {Object} defaultConfig The default config for the instance
     * @return {Axios} A new instance of Axios
     */


    function createInstance(defaultConfig) {
      var context = new Axios_1(defaultConfig);
      var instance = bind(Axios_1.prototype.request, context); // Copy axios.prototype to instance

      utils.extend(instance, Axios_1.prototype, context); // Copy context to instance

      utils.extend(instance, context);
      return instance;
    } // Create the default instance to be exported


    var axios = createInstance(defaults_1); // Expose Axios class to allow class inheritance

    axios.Axios = Axios_1; // Factory for creating new instances

    axios.create = function create(instanceConfig) {
      return createInstance(mergeConfig(axios.defaults, instanceConfig));
    }; // Expose Cancel & CancelToken


    axios.Cancel = Cancel_1;
    axios.CancelToken = CancelToken_1;
    axios.isCancel = isCancel; // Expose all/spread

    axios.all = function all(promises) {
      return Promise.all(promises);
    };

    axios.spread = spread;
    var axios_1 = axios; // Allow use of default import syntax in TypeScript

    var _default = axios;
    axios_1.default = _default;

    var axios$1 = axios_1;

    class AuthError extends Error {
        constructor(message) {
            super(message);
            this.name = this.constructor.name;
            this.message = message;
            // Obscure typescript -> es5 transpile fix
            Object.setPrototypeOf(this, new.target.prototype);
        }
    }

    function getDefaultExportFromCjs (x) {
    	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    }

    function createCommonjsModule(fn) {
      var module = { exports: {} };
    	return fn(module, module.exports), module.exports;
    }

    /*!
     * cookie
     * Copyright(c) 2012-2014 Roman Shtylman
     * Copyright(c) 2015 Douglas Christopher Wilson
     * MIT Licensed
     */
    /**
     * Module exports.
     * @public
     */

    var parse_1 = parse;
    var serialize_1 = serialize;
    /**
     * Module variables.
     * @private
     */

    var decode = decodeURIComponent;
    var encode$1 = encodeURIComponent;
    var pairSplitRegExp = /; */;
    /**
     * RegExp to match field-content in RFC 7230 sec 3.2
     *
     * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
     * field-vchar   = VCHAR / obs-text
     * obs-text      = %x80-FF
     */

    var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
    /**
     * Parse a cookie header.
     *
     * Parse the given cookie header string into an object
     * The object has the various cookies as keys(names) => values
     *
     * @param {string} str
     * @param {object} [options]
     * @return {object}
     * @public
     */

    function parse(str, options) {
      if (typeof str !== 'string') {
        throw new TypeError('argument str must be a string');
      }

      var obj = {};
      var opt = options || {};
      var pairs = str.split(pairSplitRegExp);
      var dec = opt.decode || decode;

      for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i];
        var eq_idx = pair.indexOf('='); // skip things that don't look like key=value

        if (eq_idx < 0) {
          continue;
        }

        var key = pair.substr(0, eq_idx).trim();
        var val = pair.substr(++eq_idx, pair.length).trim(); // quoted values

        if ('"' == val[0]) {
          val = val.slice(1, -1);
        } // only assign once


        if (undefined == obj[key]) {
          obj[key] = tryDecode(val, dec);
        }
      }

      return obj;
    }
    /**
     * Serialize data into a cookie header.
     *
     * Serialize the a name value pair into a cookie string suitable for
     * http headers. An optional options object specified cookie parameters.
     *
     * serialize('foo', 'bar', { httpOnly: true })
     *   => "foo=bar; httpOnly"
     *
     * @param {string} name
     * @param {string} val
     * @param {object} [options]
     * @return {string}
     * @public
     */


    function serialize(name, val, options) {
      var opt = options || {};
      var enc = opt.encode || encode$1;

      if (typeof enc !== 'function') {
        throw new TypeError('option encode is invalid');
      }

      if (!fieldContentRegExp.test(name)) {
        throw new TypeError('argument name is invalid');
      }

      var value = enc(val);

      if (value && !fieldContentRegExp.test(value)) {
        throw new TypeError('argument val is invalid');
      }

      var str = name + '=' + value;

      if (null != opt.maxAge) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += '; Max-Age=' + Math.floor(maxAge);
      }

      if (opt.domain) {
        if (!fieldContentRegExp.test(opt.domain)) {
          throw new TypeError('option domain is invalid');
        }

        str += '; Domain=' + opt.domain;
      }

      if (opt.path) {
        if (!fieldContentRegExp.test(opt.path)) {
          throw new TypeError('option path is invalid');
        }

        str += '; Path=' + opt.path;
      }

      if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') {
          throw new TypeError('option expires is invalid');
        }

        str += '; Expires=' + opt.expires.toUTCString();
      }

      if (opt.httpOnly) {
        str += '; HttpOnly';
      }

      if (opt.secure) {
        str += '; Secure';
      }

      if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;

        switch (sameSite) {
          case true:
            str += '; SameSite=Strict';
            break;

          case 'lax':
            str += '; SameSite=Lax';
            break;

          case 'strict':
            str += '; SameSite=Strict';
            break;

          default:
            throw new TypeError('option sameSite is invalid');
        }
      }

      return str;
    }
    /**
     * Try decoding a string using a decoding function.
     *
     * @param {string} str
     * @param {function} decode
     * @private
     */


    function tryDecode(str, decode) {
      try {
        return decode(str);
      } catch (e) {
        return str;
      }
    }

    var cookie = {
      parse: parse_1,
      serialize: serialize_1
    };

    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();

    var hasCookies_1 = hasCookies;

    var _cookie2 = _interopRequireDefault(cookie);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    var prefix = 'lS_';

    var CookieStorage = function () {
      function CookieStorage() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, CookieStorage);

        this.cookieOptions = Object.assign({
          path: '/'
        }, options);
        prefix = options.prefix === undefined ? prefix : options.prefix;
      }

      _createClass(CookieStorage, [{
        key: 'getItem',
        value: function getItem(key) {
          var cookies = _cookie2.default.parse(document.cookie);

          if (!cookies || !cookies.hasOwnProperty(prefix + key)) {
            return null;
          }

          return cookies[prefix + key];
        }
      }, {
        key: 'setItem',
        value: function setItem(key, value) {
          document.cookie = _cookie2.default.serialize(prefix + key, value, this.cookieOptions);
          return value;
        }
      }, {
        key: 'removeItem',
        value: function removeItem(key) {
          var options = Object.assign({}, this.cookieOptions, {
            maxAge: -1
          });
          document.cookie = _cookie2.default.serialize(prefix + key, '', options);
          return null;
        }
      }, {
        key: 'clear',
        value: function clear() {
          var cookies = _cookie2.default.parse(document.cookie);

          for (var key in cookies) {
            if (key.indexOf(prefix) === 0) {
              this.removeItem(key.substr(prefix.length));
            }
          }

          return null;
        }
      }]);

      return CookieStorage;
    }();

    var _default$1 = CookieStorage;

    function hasCookies() {
      var storage = new CookieStorage();

      try {
        var TEST_KEY = '__test';
        storage.setItem(TEST_KEY, '1');
        var value = storage.getItem(TEST_KEY);
        storage.removeItem(TEST_KEY);
        return value === '1';
      } catch (e) {
        return false;
      }
    }

    var CookieStorage_1 = /*#__PURE__*/Object.defineProperty({
      hasCookies: hasCookies_1,
      default: _default$1
    }, '__esModule', {
      value: true
    });

    var _default$2 = isSupported;
    var TEST_KEY = '__test';

    function hasStorage(name) {
      try {
        var storage = window[name];
        storage.setItem(TEST_KEY, '1');
        storage.removeItem(TEST_KEY);
        return true;
      } catch (e) {
        return false;
      }
    }

    function isSupported() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'localStorage';
      var storage = String(name).replace(/storage$/i, '').toLowerCase();

      if (storage === 'local') {
        return hasStorage('localStorage');
      }

      if (storage === 'session') {
        return hasStorage('sessionStorage');
      }

      if (storage === 'cookie') {
        return (0, CookieStorage_1.hasCookies)();
      }

      if (storage === 'memory') {
        return true;
      }

      throw new Error('Storage method `' + name + '` is not available.\n    Please use one of the following: localStorage, sessionStorage, cookieStorage, memoryStorage.');
    }

    var isSupported_1 = /*#__PURE__*/Object.defineProperty({
      default: _default$2
    }, '__esModule', {
      value: true
    });

    var _createClass$1 = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();

    function _classCallCheck$1(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    var MemoryStorage = function () {
      function MemoryStorage() {
        _classCallCheck$1(this, MemoryStorage);

        this._data = {};
      }

      _createClass$1(MemoryStorage, [{
        key: "getItem",
        value: function getItem(key) {
          return this._data.hasOwnProperty(key) ? this._data[key] : null;
        }
      }, {
        key: "setItem",
        value: function setItem(key, value) {
          return this._data[key] = String(value);
        }
      }, {
        key: "removeItem",
        value: function removeItem(key) {
          return delete this._data[key];
        }
      }, {
        key: "clear",
        value: function clear() {
          return this._data = {};
        }
      }]);

      return MemoryStorage;
    }();

    var _default$3 = MemoryStorage;
    var MemoryStorage_1 = /*#__PURE__*/Object.defineProperty({
      default: _default$3
    }, '__esModule', {
      value: true
    });

    var lib = createCommonjsModule(function (module, exports) {

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.MemoryStorage = exports.CookieStorage = exports.isSupported = exports.storage = undefined;

      var _isSupported2 = _interopRequireDefault(isSupported_1);

      var _CookieStorage2 = _interopRequireDefault(CookieStorage_1);

      var _MemoryStorage2 = _interopRequireDefault(MemoryStorage_1);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var storage = null;

      if ((0, _isSupported2.default)('localStorage')) {
        // use localStorage
        exports.storage = storage = window.localStorage;
      } else if ((0, _isSupported2.default)('sessionStorage')) {
        // use sessionStorage
        exports.storage = storage = window.sessionStorage;
      } else if ((0, _isSupported2.default)('cookieStorage')) {
        // use cookies
        exports.storage = storage = new _CookieStorage2.default();
      } else {
        // use memory
        exports.storage = storage = new _MemoryStorage2.default();
      }

      exports.default = storage;
      exports.storage = storage;
      exports.isSupported = _isSupported2.default;
      exports.CookieStorage = _CookieStorage2.default;
      exports.MemoryStorage = _MemoryStorage2.default;
    });
    var StorageWithFallback = /*@__PURE__*/getDefaultExportFromCjs(lib);

    const TOKEN_CONTAINER = 'TOKEN_CONTAINER';
    const LAST_USED = 'LAST_USED';
    const FALLBACK = 'FALLBACK';
    /**
     * TokenStorage provides an interface for reading, writing and managing OpenTicket authentication tokens
     */
    class TokenStorage {
        constructor(customStorage) {
            // The fallback token to refresh a token with if a 401 is returned,
            // assumes login tokens are longer valid than company switch tokens
            this.fallback = null;
            this.storage = customStorage || StorageWithFallback;
            this.readFromStorage();
        }
        /**
         * Get the last used token,
         * returns undefined if it is unknown
         */
        getDefaultToken() {
            return this.getTokenForCompany(this.lastUsed[0]);
        }
        /**
         * Get a token for a specific company by id,
         * returns undefined if the token cannot be found
         * @param guid - Company guid
         * @param setLastUsed - Updates the lastUsed array if true
         */
        getTokenForCompany(guid, setLastUsed = true) {
            if (!guid) {
                return;
            }
            const token = this.container[guid];
            if (!token) {
                return;
            }
            if (setLastUsed) {
                this.addLastUsed(guid);
            }
            return Object.assign({}, token);
        }
        /**
         * Set a token for a company,
         * automatically written to localStorage and updates the lastUsed array
         * @param token - the token to be saved, including the company id.
         */
        setTokenForCompany(token) {
            if (!token.company_id) {
                throw Error(`Token does not contain a company id: ${token}`);
            }
            if (!token.access_token || !token.expiry_date || !token.whitelabel_id) {
                throw Error(`Token is not complete: ${token}`);
            }
            // Add the token to the container
            this.container[token.company_id] = token;
            // Prepend the token to lastUsed array
            this.addLastUsed(token.company_id);
            // Write the updated data to localStorage
            this.writeToStorage();
        }
        /**
         * Overwrite the fallback company id
         * @param company_id - company guid
         */
        setFallbackToken(company_id) {
            if (!this.container[company_id]) {
                throw Error(`No token found for company guid: ${company_id}`);
            }
            // Set the fallback company id
            this.fallback = company_id;
            // Write the updated data to localStorage
            this.writeToStorage();
        }
        /**
         * Retrieve the fallback token
         */
        getFallbackToken() {
            return this.getTokenForCompany(this.fallback, false);
        }
        /**
         * Remove a token from storage by its company guid
         * @param company_id - company guid
         */
        removeToken(company_id) {
            if (!company_id) {
                return;
            }
            if (company_id === this.fallback) {
                throw Error('Cannot remove fallback token');
            }
            // Remove the token from the container
            delete this.container[company_id];
            // Remove the token from the lastUsed array
            this.removeLastUsed(company_id);
            // Write the updated data to localStorage
            this.writeToStorage();
        }
        /**
         * Clears localStorage
         */
        removeAllTokens() {
            this.storage.removeItem(TOKEN_CONTAINER);
            this.storage.removeItem(LAST_USED);
            this.storage.removeItem(FALLBACK);
            this.readFromStorage();
        }
        /**
         * Initialize the data this class by reading localStorage
         */
        readFromStorage() {
            try {
                // Read container from storage
                const rawContainer = this.storage.getItem(TOKEN_CONTAINER);
                this.container = rawContainer ? JSON.parse(rawContainer) : {};
                // Read last used from storage
                const lastUsed = this.storage.getItem(LAST_USED);
                this.lastUsed = lastUsed ? JSON.parse(lastUsed) : [];
                this.fallback = this.storage.getItem(FALLBACK) || null;
            }
            catch (e) {
                try {
                    this.removeAllTokens();
                }
                catch (e) {
                    console.warn('No storage available');
                }
                this.container = {};
                this.lastUsed = [];
            }
        }
        /**
         * Write all changes to localStorage
         */
        writeToStorage() {
            try {
                // Write token container
                this.storage.setItem(TOKEN_CONTAINER, JSON.stringify(this.container));
                // Write last used
                this.storage.setItem(LAST_USED, JSON.stringify(this.lastUsed));
                // Write fallback token
                if (this.fallback) {
                    this.storage.setItem(FALLBACK, this.fallback);
                }
            }
            catch (e) {
                console.warn('No storage available');
            }
        }
        /**
         * Remove a guid from the lastUsed array and save the changes
         * @param company_id - company guid
         */
        removeLastUsed(company_id) {
            if (this.lastUsed && this.lastUsed.indexOf(company_id) > -1) {
                const index = this.lastUsed.indexOf(company_id);
                this.lastUsed.splice(index, 1);
            }
        }
        /**
         * Prepend a guid to the lastUsed array and save the changes
         * @param company_id - company guid
         */
        addLastUsed(company_id) {
            this.removeLastUsed(company_id);
            this.lastUsed.unshift(company_id);
        }
    }

    class ApiError extends Error {
        constructor(error) {
            super(error.message);
            this.name = 'ApiError';
            // Find error message
            if (error.response && error.response.data) {
                if (error.response.data.error_description.message) {
                    this.message = error.response.data.error_description.message;
                }
                else if (typeof error.response.data.error_description === 'string') {
                    this.message = error.response.data.error_description;
                }
                else {
                    this.message = error.message;
                }
            }
            else {
                this.message = error.message;
            }
            if (error.response) {
                this.response = error.response;
                this.statusCode = this.response.status;
            }
        }
    }

    const DEFAULT_CONFIG = {
        baseUrl: '{{eventix-prod-api-placeholder}}',
    };
    // TODO: add function param validation for js bundle
    class OpenTicketAuthentication {
        constructor() {
            this.isLoggedIn = false;
            this.authRefreshes = 0;
            this._axiosConstructor = axios$1.create;
            // Current token
            this._token = null;
            this._refreshPromises = {};
            this._refreshOrReswitchPromises = {};
            // Intercepts 401 statuscodes to refresh the access token and retry the original request
            this._intercept401 = (error) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                if (error.response && error.response.status === 401) {
                    if (error.config.url.includes('/tokens')) {
                        if (this._config.onLogout) {
                            this._config.onLogout();
                        }
                        return Promise.reject(new ApiError(error));
                    }
                    else {
                        try {
                            if (!error.config.headers.Authorization) {
                                return Promise.reject(new AuthError('No authorization header present'));
                            }
                            // If the token has not changed during the request, refresh it.
                            // Else, continue the request with the new token
                            if (error.config.headers.Authorization === 'Bearer ' + ((_a = this._token) === null || _a === void 0 ? void 0 : _a.access_token)) {
                                yield this.refreshToken();
                            }
                            return yield this._axios.request(error.config);
                        }
                        catch (e) {
                            return Promise.reject(new AuthError('Cannot update accesstoken'));
                        }
                    }
                }
                else {
                    return Promise.reject(new ApiError(error));
                }
            });
        }
        init(config) {
            // Merge default config with given config
            this._config = Object.assign(Object.assign({}, DEFAULT_CONFIG), config);
            // Check if all values are set
            if (!this._config.clientId || !this._config.clientSecret || !this._config.baseUrl) {
                throw new AuthError('Configuration object is incomplete');
            }
            this._axios = this._config.httpClient || axios$1.create();
            this._axios.interceptors.request.use((config) => {
                var _a, _b;
                config.headers.Authorization = 'Bearer ' + ((_a = this._token) === null || _a === void 0 ? void 0 : _a.access_token);
                config.headers.Company = (_b = this._token) === null || _b === void 0 ? void 0 : _b.company_id;
                return config;
            });
            this._tokenStorage = new TokenStorage(config.storage);
            // Get token from storage
            const token = this._tokenStorage.getDefaultToken();
            if (token) {
                this._setToken(token);
            }
        }
        signup(params) {
            return __awaiter(this, void 0, void 0, function* () {
                const requestData = {
                    url: `${this._config.baseUrl}/signup`,
                    method: 'post',
                    data: Object.assign(Object.assign({}, params), { client_id: this._config.clientId }),
                };
                try {
                    yield this._axios.request(requestData);
                    return true;
                }
                catch (error) {
                    throw this.createError(error);
                }
            });
        }
        // Get validation rules for signup form
        getSignupValidationRules() {
            return __awaiter(this, void 0, void 0, function* () {
                return this._getEntity('/signup/rules', null, true);
            });
        }
        // Login the user and store the access token to TokenService.
        login(username, password) {
            return __awaiter(this, void 0, void 0, function* () {
                const requestData = {
                    url: `${this._config.baseUrl}/tokens`,
                    method: 'post',
                    data: {
                        grant_type: 'password',
                        username,
                        password,
                        client_id: this._config.clientId,
                        client_secret: this._config.clientSecret,
                    },
                };
                try {
                    const response = yield this._axios.request(requestData);
                    const companyId = this.getPreferredCompanyIdFromTokenResponse(response);
                    this._tokenStorage.removeAllTokens();
                    const token = this._tokenFromJson(response.data, companyId);
                    this._setToken(token);
                    this._tokenStorage.setFallbackToken(token.company_id);
                    return true;
                }
                catch (error) {
                    throw this.createError(error);
                }
            });
        }
        getAuthorizationURL(state) {
            const data = {
                grant_type: 'authorization_code',
                response_type: 'code',
            };
            if (state) {
                data.state = state;
            }
            if (this._config.authCodeClientId) {
                data.client_id = this._config.authCodeClientId;
            }
            if (this._config.authCodeRedirectUrl) {
                data.redirect_url = this._config.authCodeRedirectUrl;
            }
            const u = new URLSearchParams(data).toString();
            return `${this._config.authLoginBaseUrl}?` + u;
        }
        authorizeWithCode(code) {
            return __awaiter(this, void 0, void 0, function* () {
                const data = {
                    grant_type: 'authorization_code',
                    code,
                };
                if (this._config.authCodeClientSecret) {
                    data.client_secret = this._config.authCodeClientSecret;
                }
                if (this._config.authCodeClientId) {
                    data.client_id = this._config.authCodeClientId;
                }
                const requestData = {
                    url: `${this._config.authBaseUrl}/tokens`,
                    method: 'post',
                    data: data,
                };
                try {
                    const response = yield this._axios.request(requestData);
                    const companyId = this.getPreferredCompanyIdFromTokenResponse(response);
                    this._tokenStorage.removeAllTokens();
                    const token = this._tokenFromJson(response.data, companyId);
                    this._setToken(token);
                    this._tokenStorage.setFallbackToken(token.company_id);
                    return true;
                }
                catch (error) {
                    throw this.createError(error);
                }
            });
        }
        getPreferredCompanyIdFromTokenResponse(response) {
            var _a, _b;
            // v1 tokens
            if ((_a = response.data.info.company) === null || _a === void 0 ? void 0 : _a.guid) {
                return (_b = response.data.info.company) === null || _b === void 0 ? void 0 : _b.guid;
            }
            // v2 tokens
            // especially admin do require some extra checks because of how admins work,
            // the default_company_id could not be present in the token
            // if not present pick first from token
            const companyId = response.data.info.user.default_company_id;
            let companyIdFoundInToken = false;
            let firstCompanyId = null;
            response.data.info.companies.forEach((company) => {
                if (!firstCompanyId) {
                    firstCompanyId = company.guid;
                }
                if (companyId === company.guid) {
                    companyIdFoundInToken = true;
                }
            });
            return companyIdFoundInToken ? companyId : firstCompanyId;
        }
        getUser() {
            return __awaiter(this, void 0, void 0, function* () {
                return this._getEntity('/users/me');
            });
        }
        getCompany(guid) {
            return __awaiter(this, void 0, void 0, function* () {
                if (guid === 'me') {
                    return this._getEntity('/companies/me');
                }
                // Alter header when guid is set
                if (guid) {
                    console.log('Alter header for getCompany', guid);
                    this._axios.defaults.headers.common["Company"] = guid;
                }
                return this._getEntity('/companies/me');
            });
        }
        getWhitelabel() {
            return __awaiter(this, void 0, void 0, function* () {
                return this._getEntity('/whitelabels/me');
            });
        }
        getMe() {
            return __awaiter(this, void 0, void 0, function* () {
                return this._getEntity('/me');
            });
        }
        getCompanies(params) {
            return __awaiter(this, void 0, void 0, function* () {
                return this._getEntity('/switch', params);
            });
        }
        get currentCompanyGuid() {
            var _a;
            return (_a = this._token) === null || _a === void 0 ? void 0 : _a.company_id;
        }
        switchCompany(company_id, skipChecks = false) {
            return __awaiter(this, void 0, void 0, function* () {
                if (!this._token) {
                    throw new AuthError('Cannot switch companies: current token is null');
                }
                if (!company_id) {
                    throw new AuthError('No company id provided');
                }
                // // Cannot switch to current company
                if (!skipChecks && company_id === this._token.company_id) {
                    throw new AuthError('Cannot switch to current company');
                }
                const token = this._tokenStorage.getTokenForCompany(company_id);
                const fallback = this._tokenStorage.getFallbackToken();
                if (!fallback) {
                    throw Error('No token found to fall back on');
                }
                if (company_id === fallback.company_id) {
                    // We should check if fallback token is still valid here.. or kick a refresh
                    this._setToken(token);
                    return true;
                }
                // Get Current token and alter company_id, reuse token information
                if (fallback) {
                    fallback.company_id = company_id;
                    this._setToken(fallback);
                }
                return true;
            });
        }
        // Logout the current user by removing the token from storage.
        logout() {
            return __awaiter(this, void 0, void 0, function* () {
                // Remove Authorization header from the client
                this._removeAllTokens();
                this.isLoggedIn = false;
                // Logout settions
                try {
                    yield axios$1({
                        url: `${this._config.authBaseUrl}/sessions/logout`,
                        method: 'get',
                        withCredentials: true,
                    });
                }
                catch (e) {
                    console.log("Could not logout of sessions", e);
                }
                if (this._config.onLogout) {
                    // @ts-ignore
                    this._config.onLogout();
                }
            });
        }
        request(config) {
            return __awaiter(this, void 0, void 0, function* () {
                // TODO: domain check
                return this._axios(config);
            });
        }
        setCustomHeader(key, value) {
            this._axios.defaults.headers.common[key] = value;
        }
        /* START OLD DASHBOARD SUPPORT FUNCTIONS */
        refreshToken() {
            return __awaiter(this, void 0, void 0, function* () {
                const token = this._tokenStorage.getDefaultToken();
                if (!token) {
                    throw Error('No default token found');
                }
                // Get the refresh token
                return this._refreshToken(token);
            });
        }
        /**
         * Raw method to check if the current token is valid or not
         * doesn't use interceptors
         *
         * @param token
         * @private
         */
        _checkToken(token) {
            return __awaiter(this, void 0, void 0, function* () {
                // If no token, its probably not valid
                if (!token) {
                    return false;
                }
                try {
                    yield axios$1({
                        url: `${this._config.baseUrl}/me`,
                        method: 'get',
                        headers: {
                            Authorization: 'Bearer ' + token.access_token,
                        },
                    });
                    return true;
                }
                catch (e) {
                    return false;
                }
            });
        }
        /**
         * Assumption is that we reach this function after an 401
         * Goal is to ensure a valid access_token for the company_id as input
         * @param company_id
         */
        refreshOrReswitch(company_id) {
            return __awaiter(this, void 0, void 0, function* () {
                // Keep track to prevent loops
                this.authRefreshes++;
                if (this.authRefreshes > 15) {
                    this.logout();
                }
                if (!company_id) {
                    throw new AuthError('No company id provided');
                }
                // Return the pending promise if available
                if (this._refreshOrReswitchPromises[company_id]) {
                    return this._refreshOrReswitchPromises[company_id];
                }
                const promise = this._refreshOrReswitchPromises[company_id] = new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                    const fallback = this._tokenStorage.getFallbackToken();
                    if (!fallback) {
                        throw Error('No fallback token found');
                    }
                    // If are currently working for fallback company, just refresh
                    if (fallback.company_id == company_id) {
                        this._setToken(fallback);
                        yield this._refreshToken(fallback);
                        return resolve(true);
                    }
                    else {
                        // We received a 401, of a company_switch token
                        // We should ensure a valid fallback token and reswitch to the company
                        // Because tokens are being invalidated in the backend (limited amount)
                        // We'll always check if current fallback token is valid
                        // DO this by calling /me
                        const fbValid = yield this._checkToken(fallback);
                        if (!fbValid) {
                            yield this._refreshToken(fallback);
                            return resolve(true);
                        }
                        try {
                            // Get token for current company and check if still valid
                            const token = this._tokenStorage.getTokenForCompany(company_id);
                            const ccValid = yield this._checkToken(token);
                            if (!ccValid) {
                                // Current token is not valid, force refresh
                                yield this.switchCompany(company_id, true);
                            }
                            else {
                                // Current token is valid, set
                                this._setToken(token);
                            }
                        }
                        catch (e) {
                            return reject(e);
                        }
                        return resolve(true);
                    }
                }));
                try {
                    return yield promise;
                }
                catch (e) {
                    throw e;
                }
                finally {
                    // When resolved, remove the promise from the cache
                    delete this._refreshOrReswitchPromises[company_id];
                }
            });
        }
        getAccessToken() {
            return this._token;
        }
        /* END OLD DASHBOARD SUPPORT FUNCTIONS */
        _getEntity(path, params, unauthenticated) {
            return __awaiter(this, void 0, void 0, function* () {
                // Check if logged in
                if (!this.isLoggedIn && !unauthenticated) {
                    throw Error('Login to perform authenticated requests');
                }
                const requestData = {
                    url: `${this._config.baseUrl}${path}`,
                    method: 'get',
                    params,
                };
                try {
                    const response = yield this._axios.request(requestData);
                    return response.data;
                }
                catch (e) {
                    throw new ApiError(e);
                }
            });
        }
        // Refresh the access token.
        _refreshToken(token) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                const company_id = token.company_id;
                const currentToken = token.company_id === ((_a = this._token) === null || _a === void 0 ? void 0 : _a.company_id);
                if (!company_id) {
                    throw Error(`No company id on token ${token}`);
                }
                if (this._refreshPromises[company_id]) {
                    return this._refreshPromises[company_id];
                }
                this._refreshPromises[company_id] = new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                    const requestData = {
                        url: `${this._config.baseUrl}/tokens`,
                        method: 'post',
                        data: {
                            grant_type: 'refresh_token',
                            refresh_token: token === null || token === void 0 ? void 0 : token.refresh_token,
                            client_id: this._config.clientId,
                            client_secret: this._config.clientSecret,
                        },
                    };
                    const http = this._axiosConstructor();
                    try {
                        const response = yield http.request(requestData);
                        const token = this._tokenFromJson(response.data, company_id);
                        if (currentToken) {
                            this._setToken(token);
                        }
                        else {
                            this._tokenStorage.setTokenForCompany(token);
                        }
                        resolve(token);
                    }
                    catch (error) {
                        reject(error);
                    }
                    finally {
                        delete this._refreshPromises[company_id];
                    }
                }));
                return this._refreshPromises[company_id];
            });
        }
        // Set a new access token for the API
        _setToken(token) {
            if (!token) {
                throw new AuthError('Cannot set access token: is null or undefined');
            }
            this._token = token;
            this._mount401Interceptor();
            this._tokenStorage.setTokenForCompany(token);
            this.isLoggedIn = true;
        }
        // Remove the current access tokenthrow this.createError(error);
        _removeAllTokens() {
            this.isLoggedIn = false;
            this._unmount401Interceptor();
            if (this._token) {
                this._tokenStorage.removeAllTokens();
                this._token = null;
            }
        }
        // Add the 401 interceptor to axios
        _mount401Interceptor() {
            this._interceptorID = this._axios.interceptors.response.use((response) => response, this._intercept401);
        }
        // Remove the 401 interceptor from axios
        _unmount401Interceptor() {
            if (this._interceptorID) {
                this._axios.interceptors.response.eject(this._interceptorID);
            }
        }
        _tokenFromJson(rawToken, companyId) {
            const timestamp = Math.round(new Date().getTime() / 1000);
            return {
                company_id: companyId,
                whitelabel_id: rawToken.info.whitelabel.guid,
                access_token: rawToken.access_token,
                refresh_token: rawToken === null || rawToken === void 0 ? void 0 : rawToken.refresh_token,
                expiry_date: timestamp + rawToken.expires_in,
                refresh_token_expiry_date: timestamp + (rawToken === null || rawToken === void 0 ? void 0 : rawToken.refresh_token_expires_in),
            };
        }
        createError(error) {
            var _a;
            if (error.isAxiosError) {
                if ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) {
                    return error.response.data;
                }
                return new ApiError(error);
            }
            else if (error instanceof ApiError) {
                return error;
            }
            else {
                return new AuthError(error.message);
            }
        }
    }

    class ApiClientError extends Error {
        constructor(message) {
            super(message);
            this.name = 'ApiClientError';
            this.message = message;
        }
    }

    // @ts-ignore
    window.OpenTicket = window.OpenTicket || {};
    // @ts-ignore
    window.OpenTicket.Authorization = new OpenTicketAuthentication();

    exports.ApiClientError = ApiClientError;
    exports.ApiError = ApiError;
    exports.AuthError = AuthError;
    exports.default = OpenTicketAuthentication;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
